import type { CrossroadsLog } from '@/api/hooks/useIntegrationLogs'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { Horizontal, Texto } from '@gravitate-js/excalibrr'
import { Tooltip } from 'antd'
import { issueCategoryLabel } from './LogDetailsPanel/categories'

const CELL_STYLE = { cursor: 'pointer' }
const ICON_STYLE = { color: 'var(--theme-error, #ff4d4f)' }

/**
 * A log's issue category, as rendered by both the overview grid's Latest/
 * First Issue columns and the detail grid's Issue column. Renders nothing
 * for a log with no issue (e.g. a success log).
 */
export function IssueCategoryCell({ log }: { log?: CrossroadsLog | null }) {
  const label = issueCategoryLabel(log)
  if (!log || !label) return null
  return (
    <Tooltip title={log.detail?.message ?? log.title}>
      <Horizontal gap={6} alignItems='center' style={CELL_STYLE}>
        <ExclamationCircleOutlined style={ICON_STYLE} />
        <Texto>{label}</Texto>
      </Horizontal>
    </Tooltip>
  )
}
